import { PlatformPage } from './PlatformPage'
import { StaffInvitationsTab } from './tabs/StaffInvitationsTab'

export function StaffInvitationsPage() {
  return (
    <PlatformPage
      title="Staff Invitations"
      description="Invite new Bokapsys staff and track pending invitations."
    >
      <StaffInvitationsTab />
    </PlatformPage>
  )
}
